import { array, number, object, string, tuple } from 'yup';

export const FuelGradesConfigurationSchema = object({
  /**
   * Order in mapping array determines sorting order
   */
  mapping: array(tuple([string().required(), array(string().required()).required().min(1)]).required()).required(),
  default: string().defined(),
});

export const LocalRetailerConfigurationSchema = object({
  version: number<3>().min(3).max(3).required(),
  universalLinkOrigins: array(string().url().required()).required().min(1),
  fuelGrades: FuelGradesConfigurationSchema.required(),
});
